import React from "react";

interface SettlementChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onViewNotice: () => void;
}

const SETTLEMENT_CHANGE_NOTICE_URL =
  "https://sellerpedia.super.site/4%ec%9b%94%eb%b6%80%ed%84%b0-%ec%a0%95%ec%82%b0-%ec%a0%88%ec%b0%a8%ea%b0%80-%eb%8d%94-%ea%b0%84%eb%8b%a8%ed%95%b4%ec%a7%91%eb%8b%88%eb%8b%a4";

const SettlementChangeModal: React.FC<SettlementChangeModalProps> = ({
  isOpen,
  onClose,
  onViewNotice,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4">
        <div className="text-center mb-4">
          <div className="text-6xl">📢</div>
        </div>

        <div className="text-center space-y-3 mb-6">
          <h2 className="text-xl font-bold text-gray-800">
            정산 방식 변경 안내
          </h2>
          <p className="text-gray-600">
            4월부터 월 1회 자동 정산으로 변경됩니다.
          </p>
          <div className="text-left bg-amber-50 border border-amber-200 rounded-xl p-3">
            <p className="text-sm text-amber-800 font-medium">
              변경되는 핵심 내용
            </p>
            <p className="text-sm text-amber-800 mt-1">
              전월 거래내역 기준으로 매달 영업일 첫날 자동 정산되며,
              별도 정산 요청이나 현금영수증 발행은 더 이상 필요하지 않습니다.
            </p>
          </div>
          <p className="text-sm text-gray-500">
            세무 처리와 참고자료 안내는 보러가기에서 확인해주세요
          </p>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-4 bg-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-300 transition-colors"
          >
            닫기
          </button>
          <button
            onClick={onViewNotice}
            className="flex-1 py-3 px-4 bg-[#1562fc] text-white rounded-xl font-medium hover:bg-[#124ab7] transition-colors"
          >
            보러가기
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettlementChangeModal;
export { SETTLEMENT_CHANGE_NOTICE_URL };
